import styled from 'styled-components';

interface RatingStyleProps {
  opacity: number;
}

const RatingDistributionContainer = styled.div``;

const Border = styled.div`
  border-radius: 50px;
  border: 0.5px solid #cccccc;
  padding: 0px 10px;
  display: flex;
  justify-content: center;
  align-items: center;

  > span {
    line-height: 18px;
  }

  > * {
    margin-left: 2px;
    margin-right: 2px;
  }
`;

const RatingStyle = styled.div<RatingStyleProps>`
  color: ${({ theme }) => theme.grey.dark};
  font-size: ${({ theme }) => theme.fontSize.xs};
  line-height: 1.5;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 5px 0;
  font-weight: normal;
  cursor: ${({ opacity }) => (opacity < 1 ? 'default' : 'pointer')};
  opacity: ${({ opacity }) => opacity};

  &.active {
    font-weight: bold;

    > div {
      &:first-child {
        border: 1px solid #666;
      }
    }
  }

  > * {
    margin: 0 5px;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    transition: all 0.3s ease-in;

    > div {
      & svg {
        > path {
          fill: #eecc04;
        }
      }

      > :last-child {
        &:before {
          background: #eecc04;
        }
      }
    }
  }
`;

export default RatingDistributionContainer;
export { RatingDistributionContainer, RatingStyle, Border };
